export default __webpack_public_path__ + "static/media/intercom.28c0956c.png";